<template>
  <body class="kb-theme--tiles kb-page--index">
    <header>
      <div
        class="kb-header"
        data-preview-id="kb-header"
      >
        <div
          id="kb-header"
          class="kb-header-inner"
        >
          <div class="kb-header__logo">
            <a href="/qa">
              <img
                :src="logoImage"
                alt="会社ロゴ"
              >
            </a>
          </div>
          <a
            class="kb-header__title"
            href="/qa"
          > サポートトップ </a>
          <nav
            id="kb-header__nav"
            class="kb-header__nav"
            role="navigation"
          >
            <ul>
              <div class="kb-header__lang-switcher-container">
                <button
                  class="kb-header__lang-switcher-toggle kb-button--link"
                  data-kbui-dropdown-contents="lang-switcher"
                >
                  <div class="kb-header__lang-switcher-inner">
                    <div class="kb-header__lang-switcher-icon">
                      <svg
                        width="23"
                        height="23"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <g fill-rule="evenodd">
                          <path
                            id="a"
                            d="M18.6 17.07a3.86 3.86 0 01-.5-2.35c.07-.45.24-.89.28-1.34.04-.46-.08-.97-.46-1.23-.8-.56-2 .43-2.84-.07a1.85 1.85 0 01-.58-.67c-.23-.4-.47-.8-.52-1.25-.05-.45.15-.96.57-1.12.1-.05.22-.07.3-.14.16-.13.14-.38.2-.58.14-.51.76-.69 1.3-.78.5-.08 1-.17 1.5-.11.78.09 1.54.5 2.29.67a9.49 9.49 0 01-1.53 8.97m-5.54-2.26c-.34.46-.82.81-1.14 1.3-.2.3-.34.67-.6.94-.21.22-.5.37-.72.59-.37.37-.5.93-.45 1.46.05.52.25 1.02.45 1.5v.02a9.53 9.53 0 01-1.5-.22c-.28-1.34-.5-2.7-.64-4.07-.03-.27-.06-.55-.18-.8-.42-.75-1.71-.92-1.78-1.78-.03-.36.18-.68.3-1.01.1-.34.07-.8-.26-.93l-.3-.07c-.34-.1-.5-.47-.75-.71-.31-.3-.84-.01-1.2-.24-.36-.23-.49-.65-.84-.87-.36-.23-.67-.74-.37-1.03-.36 0-.7-.13-1-.33A9.4 9.4 0 019.5 1.87c.06.03.1.06.17.08.43.15.9 0 1.35-.08.45-.06 1 0 1.22.4.05.1.08.23.06.34-.08.39-.6.45-.97.6-.33.13-.6.4-.73.74.28.08.57.16.78.36.2.2.31.53.15.77-.16.25-.5.28-.8.33-.88.17-1.72.8-2.59.57-.2-.06-.39-.16-.6-.15-.2 0-.42.2-.36.39.47.23 1.03.71.76 1.17-.16.28-.6.36-.7.67-.1.29.03.75-.27.78-.1 0-.2-.07-.29-.13a1.4 1.4 0 00-1.55-.01c-.1.07-.2.16-.24.28-.1.3.23.59.54.66.31.08.66.06.93.23.4.25.53.86.98.96.26.06.51-.07.76-.13.74-.2 1.51.17 2.13.62.61.45 1.17 1.01 1.87 1.3.4.17.86.26 1.12.6.36.44.19 1.12-.15 1.59m1.91-8.54c.23-.34.93-.4.8-.79-.4-.05-.69-.53-.56-.91a.74.74 0 011-.4c.22.12.35.34.55.5.19.14.5.2.65.01.06-.08.08-.19.1-.3 0-.06.03-.12.04-.19l.33.3a9.5 9.5 0 011.7 2.34c-.4.14-.84.26-1.25.16-.37-.1-.7-.35-1.07-.37-.33-.03-.65.12-.95.25-.3.14-.64.25-.96.16-.32-.1-.56-.49-.38-.76m7.35 3.92l-.07-.54-.06-.4a12 12 0 00-.15-.7l-.04-.17a11.3 11.3 0 00-1.53-3.43l-.07-.1a11.33 11.33 0 00-1.31-1.57A11.11 11.11 0 009.53.14L9.19.2a11.7 11.7 0 00-2.84.91l-.22.1a9.2 9.2 0 00-1.31.8c-.17.1-.33.23-.49.35l-.3.24A10.77 10.77 0 002 4.83l-.1.12c-.39.59-.72 1.21-1 1.86v.02a11.11 11.11 0 008.62 15.4 13.47 13.47 0 001.7.13 11.1 11.1 0 007.89-3.26 11.74 11.74 0 001.11-1.32l.05-.06.5-.74.08-.14.38-.72.1-.22a13.39 13.39 0 00.62-1.63l.11-.44c.05-.19.1-.37.13-.55l.09-.6.05-.43a10.92 10.92 0 000-2.06"
                          />
                        </g>
                      </svg>
                    </div>
                    <div class="kb-header__lang-switcher__selected-lang">
                      日本語
                    </div>
                    <div class="kb-header__lang-switcher__caret" />
                  </div>
                </button>
                <div
                  class="kbui-dropdown-contents"
                  data-kbui-dropdown-name="lang-switcher"
                >
                  <div class="kb-header__langs-dropdown">
                    <ul>
                      <li>
                        <a
                          href="/qa"
                          class="kbui-dropdown__link"
                        >
                          <div class="kb-header__langs-dropdown__link-content">
                            English
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <li class="kb-header__support-form-link">
                <a href="/contact">お問い合わせ</a>
              </li>
            </ul>
          </nav>
          <nav
            id="kb-header__langs-nav"
            class="kb-header__nav kb-header__langs-nav"
            role="navigation"
          >
            <ul>
              <li>
                <a href="#"> English </a>
              </li>
            </ul>
          </nav>

          <div class="kb-header__nav-controls-container">
            <button
              id="kb-header__close-target"
              class="kb-header__nav-close"
              role="button"
              aria-label="Close main navigation menu"
              aria-controls="kb-header__nav kb-header__langs-nav"
            >
              <span
                class="kb-icon close"
                aria-hidden="true"
              >
                <svg
                  width="16"
                  height="17"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    fill="#2D3E50"
                    fill-rule="nonzero"
                  >
                    <path
                      d="M15.07107 1.42893c.59587.59588.88893 1.23239.0505 2.07081L2.99975 15.62158c-.83842.83842-1.48089.5394-2.0708-.05051C.33305 14.97519.04 14.33868.87841 13.50026L13.00026 1.37842c.83842-.83842 1.48089-.5394 2.0708.05051z"
                    />
                    <path
                      d="M15.07107 15.57107c-.59588.59587-1.23239.88893-2.07081.0505L.87842 3.49975C.04 2.66132.33902 2.01885.92893 1.42894 1.52481.83305 2.16132.54 2.99974 1.37841l12.12184 12.12184c.83842.83842.5394 1.48089-.05051 2.0708z"
                    />
                  </g>
                </svg>
              </span>
            </button>
            <button
              id="kb-header__langs-nav-target"
              class="kb-header__nav-toggle"
              role="button"
              aria-controls="kb-header__langs-nav"
            >
              <span class="kb-icon langs">
                <svg
                  width="23"
                  height="23"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g fill-rule="evenodd">
                    <path
                      id="a"
                      d="M18.6 17.07a3.86 3.86 0 01-.5-2.35c.07-.45.24-.89.28-1.34.04-.46-.08-.97-.46-1.23-.8-.56-2 .43-2.84-.07a1.85 1.85 0 01-.58-.67c-.23-.4-.47-.8-.52-1.25-.05-.45.15-.96.57-1.12.1-.05.22-.07.3-.14.16-.13.14-.38.2-.58.14-.51.76-.69 1.3-.78.5-.08 1-.17 1.5-.11.78.09 1.54.5 2.29.67a9.49 9.49 0 01-1.53 8.97m-5.54-2.26c-.34.46-.82.81-1.14 1.3-.2.3-.34.67-.6.94-.21.22-.5.37-.72.59-.37.37-.5.93-.45 1.46.05.52.25 1.02.45 1.5v.02a9.53 9.53 0 01-1.5-.22c-.28-1.34-.5-2.7-.64-4.07-.03-.27-.06-.55-.18-.8-.42-.75-1.71-.92-1.78-1.78-.03-.36.18-.68.3-1.01.1-.34.07-.8-.26-.93l-.3-.07c-.34-.1-.5-.47-.75-.71-.31-.3-.84-.01-1.2-.24-.36-.23-.49-.65-.84-.87-.36-.23-.67-.74-.37-1.03-.36 0-.7-.13-1-.33A9.4 9.4 0 019.5 1.87c.06.03.1.06.17.08.43.15.9 0 1.35-.08.45-.06 1 0 1.22.4.05.1.08.23.06.34-.08.39-.6.45-.97.6-.33.13-.6.4-.73.74.28.08.57.16.78.36.2.2.31.53.15.77-.16.25-.5.28-.8.33-.88.17-1.72.8-2.59.57-.2-.06-.39-.16-.6-.15-.2 0-.42.2-.36.39.47.23 1.03.71.76 1.17-.16.28-.6.36-.7.67-.1.29.03.75-.27.78-.1 0-.2-.07-.29-.13a1.4 1.4 0 00-1.55-.01c-.1.07-.2.16-.24.28-.1.3.23.59.54.66.31.08.66.06.93.23.4.25.53.86.98.96.26.06.51-.07.76-.13.74-.2 1.51.17 2.13.62.61.45 1.17 1.01 1.87 1.3.4.17.86.26 1.12.6.36.44.19 1.12-.15 1.59m1.91-8.54c.23-.34.93-.4.8-.79-.4-.05-.69-.53-.56-.91a.74.74 0 011-.4c.22.12.35.34.55.5.19.14.5.2.65.01.06-.08.08-.19.1-.3 0-.06.03-.12.04-.19l.33.3a9.5 9.5 0 011.7 2.34c-.4.14-.84.26-1.25.16-.37-.1-.7-.35-1.07-.37-.33-.03-.65.12-.95.25-.3.14-.64.25-.96.16-.32-.1-.56-.49-.38-.76m7.35 3.92l-.07-.54-.06-.4a12 12 0 00-.15-.7l-.04-.17a11.3 11.3 0 00-1.53-3.43l-.07-.1a11.33 11.33 0 00-1.31-1.57A11.11 11.11 0 009.53.14L9.19.2a11.7 11.7 0 00-2.84.91l-.22.1a9.2 9.2 0 00-1.31.8c-.17.1-.33.23-.49.35l-.3.24A10.77 10.77 0 002 4.83l-.1.12c-.39.59-.72 1.21-1 1.86v.02a11.11 11.11 0 008.62 15.4 13.47 13.47 0 001.7.13 11.1 11.1 0 007.89-3.26 11.74 11.74 0 001.11-1.32l.05-.06.5-.74.08-.14.38-.72.1-.22a13.39 13.39 0 00.62-1.63l.11-.44c.05-.19.1-.37.13-.55l.09-.6.05-.43a10.92 10.92 0 000-2.06"
                    />
                  </g>
                </svg>
              </span>
            </button>

            <button
              id="kb-header__main-nav-target"
              class="kb-header__nav-toggle"
              role="button"
              aria-label="Open main navigation menu"
              aria-controls="kb-header__nav"
            >
              <span class="kb-icon menu">
                <svg
                  width="25"
                  height="17"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    fill="#2D3E50"
                    fill-rule="nonzero"
                  >
                    <path
                      d="M24.56897 2.295c0 .85-.2931 1.513-1.72414 1.513H2.15517C.72414 3.808.43103 3.1365.43103 2.295c0-.85.2931-1.513 1.72414-1.513h20.68966c1.43103 0 1.72414.6715 1.72414 1.513zM24.56897 8.8315c0 .85-.2931 1.513-1.72414 1.513H2.15517c-1.43103 0-1.72414-.6715-1.72414-1.513 0-.85.2931-1.513 1.72414-1.513h20.68966c1.43103 0 1.72414.6715 1.72414 1.513zM24.56897 15.3595c0 .85-.2931 1.513-1.72414 1.513H2.15517c-1.43103 0-1.72414-.6715-1.72414-1.513 0-.85.2931-1.513 1.72414-1.513h20.68966c1.43103 0 1.72414.6715 1.72414 1.513z"
                    />
                  </g>
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>

      <div
        class="
            kb-search-section kb-search-section--full
            kb-search-section-with-image
          "
        data-preview-id="kb-search-section"
      >
        <div class="kb-search-section__content content-container">
          <h1 class="kb-search-section__title">
            <div
              class="kb-search-section__title_inner"
              data-preview-id="kb-search-title"
            >
              どんなことでお困りですか？
            </div>
          </h1>
          <div
            class="kb-search"
            kb-language-tag="ja"
            kb-group-id="46028942943"
          >
            <div class="kb-search__placeholder" />
            <div class="kb-search__box">
              <div class="kb-search__bar">
                <svg
                  class="kb-search__mag"
                  width="15"
                  height="15"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.02 12.672l-3.64-3.64a5.687 5.687 0 0 0 1.06-3.312A5.726 5.726 0 0 0 5.72 0 5.726 5.726 0 0 0 0 5.72a5.726 5.726 0 0 0 5.72 5.72 5.687 5.687 0 0 0 3.311-1.06l3.641 3.64a.95.95 0 0 0 1.348 0 .953.953 0 0 0 0-1.348zm-8.3-3.139a3.813 3.813 0 1 1 0-7.626 3.813 3.813 0 0 1 0 7.626z"
                    fill="#4A4A4A"
                    fill-rule="evenodd"
                  />
                </svg>
                <form @submit="search">
                  <input
                    v-model="searchKeyword"
                    type="text"
                    class="kb-search__input"
                    name="keyword"
                    autocomplete="off"
                    placeholder="回答を検索"
                    required
                  >
                </form>
                <svg
                  class="kb-search__close"
                  width="14"
                  height="14"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    stroke="#4A4A4A"
                    stroke-width="2"
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M1 12.314L12.314 1M12.314 12.314L1 1" />
                  </g>
                </svg>
              </div>
              <ul
                class="kb-search__suggestions"
                data-lang="「」の結果"
              />
            </div>
          </div>
        </div>
      </div>
    </header>
    <router-view />
    <footer>
      <div
        class="kb-sticky-footer"
        data-preview-id="kb-footer"
      >
        <div class="kb-footer">
          <div class="kb-footer__center-aligned-content">
            <div class="kb-footer__title">
              © Well-Beings Co., Ltd. All Rights Reserved.
            </div>
          </div>
          <div class="kb-footer__links-container">
            <ul class="kb-footer__links columns__one">
              <li class="kb-footer__support-form-link">
                <a href="/contact">お問い合わせ</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </body>
</template>

<script>
import logoImage from '@images/logo/brand_basic_horizontal.svg'
export default {
  name: 'FaqLayout',
  components: {
  },
  data() {
    return {
      title: '',
      logoImage,
      searchKeyword: this.$route.query?.keyword ?? null,
    }
  },
  computed: {
    keyword() {
      return this.$route.query?.keyword
    }
  },
  watch:{
    keyword(value){
      this.searchKeyword = value
    }
  },
  mounted() {
    var scripts = [
      'https://cdn2.hubspot.net/hub/7052064/hub_generated/template_assets/1718391909724/hubspot/themes/knowledge/assets/kbdom.min.js',
      'https://cdn2.hubspot.net/hub/7052064/hub_generated/template_assets/1718391913398/hubspot/themes/knowledge/assets/sticky-header.min.js',
      'https://cdn2.hubspot.net/hub/7052064/hub_generated/template_assets/1718391909145/hubspot/themes/knowledge/assets/smooth-anchors-scrolling.min.js'
    ]
    scripts.forEach(script => {
      let tag = document.createElement('script')
      tag.setAttribute('src', script)
      document.head.appendChild(tag)
    })
    this.searchKeyword = this.$route.query?.keyword
  },
  methods: {
    search() {
      this.$router.push({ name: 'search', query: { keyword: this.searchKeyword } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/faq/faq.css";
@import "~styles/faq/faq-main.css";
@import "~styles/faq/faq-form.css";
// @import '~styles/faq/faq-font-awesome.css';
</style>
